import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs';
import type { CalendarComponent } from 'owa-calendar-usage-instrumentation';

/**
 * Updates the CAS suggestions if necessary
 */
export const refreshTimeSuggestions = action(
    'refreshTimeSuggestions',
    (event: CalendarEvent, attendeesChanged: boolean, viewStateId: string | null) => ({
        event,
        attendeesChanged,
        viewStateId,
    })
);

/**
 * Initialize the time suggestions
 */
export const initializeTimeSuggestions = action(
    'initializeTimeSuggestions',
    (
        event: CalendarEvent,
        shouldAdjustStartTimeEndTime: boolean,
        calendarComponent: CalendarComponent,
        viewStateId: string | null
    ) => ({
        event,
        shouldAdjustStartTimeEndTime,
        calendarComponent,
        viewStateId,
    })
);

export const setCalendarComponent = action(
    'setCalendarComponent',
    (calendarComponent: CalendarComponent, viewStateId: string | null) => ({
        calendarComponent,
        viewStateId,
    })
);
